import React from 'react';
import PrivateRoute from './PrivateRoute';
import { getPathApp } from '../utils/util';
import VolumeParameters from '../containers/Volume/VolumeParameters';
import Volume from '../containers/Volume/Home/Volume';

let aux = 0;
const pathurl = getPathApp(window);
const VolumeRoute = [
    <PrivateRoute key={aux += 1} path={`${pathurl}/VolumeParameters`} component={VolumeParameters} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/volume`} component={Volume} />,

];

export default VolumeRoute;
